import { FC } from 'react'
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom'
import {
  AtendimentoType,
  IconPaths,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '_metronic/helpers'
import { RowActions, useModal, useToast } from 'app/components'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { EmpresaValoresModal } from '../../components/modal/EmpresaValoresModal'
import { deleteValoresByEmpresa, getValoresEmpresaByValor } from '../../core/_requests'
import { ValorEmpresaDtoRemover, ValorEmpresaList } from '../../core/_models'

type Props = {
  valorEmpresa: ValorEmpresaList
}

export const EmpresaValoresActionCell: FC<Props> = ({ valorEmpresa }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { id } = useParams<{ id: string }>()
  const { refetch } = useQueryResponse()

  const nome = [valorEmpresa.tipo, valorEmpresa.especialidade?.nome].filter(Boolean).join(' · ')

  const openEditModal = () =>
    showModal({
      title: 'Editar valor',
      content: <EmpresaValoresModal idEmpresa={Number(id)} />,
      fetchers: {
        valorEmpresa: () => getValoresEmpresaByValor(Number(id), valorEmpresa.id),
      },
    })

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir valor?',
      text: `O valor de ${nome || 'atendimento'} será excluído.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      const data: ValorEmpresaDtoRemover = {
        tipo: valorEmpresa.tipo as AtendimentoType,
        especialidades: valorEmpresa.especialidade ? [valorEmpresa.especialidade.id] : null,
      }
      await deleteValoresByEmpresa(Number(id), data)
      Swal.close()
      showToast({ variant: 'success', title: 'Valor excluído.' })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={`valor de ${nome || 'atendimento'}`}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
